import { isNumber } from 'lodash-es';
export * from "./form";
export * from "./props";
export var isMobileDevice = /(phone|pad|pod|iPhone|iPod|iPad|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
export var isCommonUrl = function isCommonUrl() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var urlReg = /(^(http|https):\/\/([\w\-]+\.)+[\w\-]+(\/[\w\u4e00-\u9fa5\-\.\/?\@\%\!\&=\+\~\:\#\;\,]*)?)/;
  return !!str.match(urlReg);
};

// List
export var ListType = /*#__PURE__*/function (ListType) {
  ListType["number"] = "number";
  ListType["checkbox"] = "checkbox";
  ListType["bulleted"] = "bulleted";
  return ListType;
}({});
export var listTypes = [ListType.number, ListType.checkbox, ListType.bulleted];

// Divider
export var DividerType = /*#__PURE__*/function (DividerType) {
  DividerType["number"] = "number";
  DividerType["line"] = "line";
  return DividerType;
}({});
export var dividerTypes = [DividerType.number, DividerType.line];

// FAQ
export var FaqQuestionTypes = [{
  label: 'single choice',
  value: 1
}, {
  label: 'multiple choice',
  value: 2
}];

// Carousel
export var SlideArrowPosition = /*#__PURE__*/function (SlideArrowPosition) {
  SlideArrowPosition["inner"] = "inner";
  SlideArrowPosition["outer"] = "outer";
  return SlideArrowPosition;
}({});
export var SlideSwitch = /*#__PURE__*/function (SlideSwitch) {
  SlideSwitch["on"] = "on";
  SlideSwitch["off"] = "off";
  return SlideSwitch;
}({});
export var slideArrowPositions = [{
  label: 'inner',
  value: SlideArrowPosition.inner
}, {
  label: 'outer',
  value: SlideArrowPosition.outer
}];
export var slidesToShows = [{
  label: '1',
  value: 1
}, {
  label: '2',
  value: 2
}, {
  label: '3',
  value: 3
}, {
  label: '4',
  value: 4
}];

// Quote
export var QuoteType = /*#__PURE__*/function (QuoteType) {
  QuoteType["quoteA"] = "quoteA";
  QuoteType["quoteB"] = "quoteB";
  QuoteType["quoteC"] = "quoteC";
  return QuoteType;
}({});
export var quoteTypes = [{
  label: 'quote a',
  value: QuoteType.quoteA
}, {
  label: 'quote b',
  value: QuoteType.quoteB
}, {
  label: 'quote c',
  value: QuoteType.quoteC
}];

// TextButton
export var TextButtonType = /*#__PURE__*/function (TextButtonType) {
  TextButtonType["horizontal"] = "horizontal";
  TextButtonType["vertical"] = "vertical";
  return TextButtonType;
}({});
export var textButtonTypes = [{
  label: 'horizontal',
  value: TextButtonType.horizontal
}, {
  label: 'vertical',
  value: TextButtonType.vertical
}];
export var KnowledgeResultType = /*#__PURE__*/function (KnowledgeResultType) {
  KnowledgeResultType["correct"] = "correct";
  KnowledgeResultType["incorrect"] = "incorrect";
  return KnowledgeResultType;
}({});

// File
export var FileStateType = /*#__PURE__*/function (FileStateType) {
  FileStateType["success"] = "success";
  FileStateType["error"] = "error";
  return FileStateType;
}({});
export var QaResultType = /*#__PURE__*/function (QaResultType) {
  QaResultType["correct"] = "correct";
  QaResultType["incorrect"] = "incorrect";
  return QaResultType;
}({});
// Scheme
export var BackgroundType = /*#__PURE__*/function (BackgroundType) {
  BackgroundType["color"] = "color";
  BackgroundType["image"] = "image";
  return BackgroundType;
}({});
export var backgroundTypes = [{
  label: 'color',
  value: BackgroundType.color
}, {
  label: 'image',
  value: BackgroundType.image
}];
export var ColorSchemesType = /*#__PURE__*/function (ColorSchemesType) {
  ColorSchemesType[ColorSchemesType["neutral"] = 0] = "neutral";
  ColorSchemesType[ColorSchemesType["blue"] = 1] = "blue";
  ColorSchemesType[ColorSchemesType["pink"] = 2] = "pink";
  ColorSchemesType[ColorSchemesType["purple"] = 3] = "purple";
  ColorSchemesType[ColorSchemesType["red"] = 4] = "red";
  return ColorSchemesType;
}({});
export var ColorSchemeList = [{
  name: 'Neutral',
  dot: '#1A71FF',
  title: 'Title',
  titleColor: '#2E3346',
  content: 'Body text',
  contentColor: '#2E3346',
  value: ColorSchemesType.neutral,
  backgroundColor: '#fff'
}, {
  name: 'Blue',
  dot: '#1A71FF',
  title: 'Title',
  titleColor: '#2E3346',
  content: 'Body text',
  contentColor: '#2E3346',
  value: ColorSchemesType.blue,
  backgroundColor: '#E8F1FF'
}, {
  name: 'Pink',
  dot: '#FF3399',
  title: 'Title',
  titleColor: '#8C1D5C',
  content: 'Body text',
  contentColor: '#2E3346',
  value: ColorSchemesType.pink,
  backgroundColor: '#FFEBF5'
}, {
  name: 'Purple',
  dot: '#AA3CFF',
  title: 'Title',
  titleColor: '#5D2299',
  content: 'Body text',
  contentColor: '#2E3346',
  value: ColorSchemesType.purple,
  backgroundColor: '#F7EDFF'
}, {
  name: 'Red',
  dot: '#C9060C',
  title: 'Title',
  titleColor: '#7A0408',
  content: 'Body text',
  contentColor: '#2E3346',
  value: ColorSchemesType.red,
  backgroundColor: '#FBEBEC'
}];
export var BackgroundSchemeType = /*#__PURE__*/function (BackgroundSchemeType) {
  BackgroundSchemeType[BackgroundSchemeType["neutral"] = 0] = "neutral";
  BackgroundSchemeType[BackgroundSchemeType["blue"] = 1] = "blue";
  BackgroundSchemeType[BackgroundSchemeType["pink"] = 2] = "pink";
  BackgroundSchemeType[BackgroundSchemeType["purple"] = 3] = "purple";
  BackgroundSchemeType[BackgroundSchemeType["red"] = 4] = "red";
  BackgroundSchemeType[BackgroundSchemeType["default"] = 5] = "default";
  return BackgroundSchemeType;
}({});
export var BackgroundSchemeList = [{
  name: 'Neutral',
  value: BackgroundSchemeType.neutral,
  backgroundColor: '#fff',
  backgroundImageIcon: 'https://img.lazcdn.com/us/media/8e4379cb57666a1b7a997877f574ec10-160-160.png',
  backgroundImage: 'https://img.lazcdn.com/us/media/f0c6e984af800b39cd44aefffa200636-1920-1340.jpg'
}, {
  name: 'Blue',
  value: BackgroundSchemeType.blue,
  backgroundColor: '#E8F1FF',
  backgroundImageIcon: 'https://img.lazcdn.com/us/media/fbb04d568b6fe35b87f4d3a368c45c8e-160-160.png',
  backgroundImage: 'https://img.lazcdn.com/us/media/f20bdd7a88e5d063a0072e10ea312673-1920-1340.jpg'
}, {
  name: 'Pink',
  value: BackgroundSchemeType.pink,
  backgroundColor: '#FFEBF5',
  backgroundImageIcon: 'https://img.lazcdn.com/us/media/9b342a9834439b99a1dec6e31f232996-160-160.png',
  backgroundImage: 'https://img.lazcdn.com/us/media/b7160ab1a81ea14a857716cf42a692f8-1920-1340.jpg'
}, {
  name: 'Purple',
  value: BackgroundSchemeType.purple,
  backgroundColor: '#F7EDFF',
  backgroundImageIcon: 'https://img.lazcdn.com/us/media/3a9c6da1511b4d9536ddeea5fb95d4cb-160-160.png',
  backgroundImage: 'https://img.lazcdn.com/us/media/941e6ca503efd7a6f2d340f1647cb4e0-1920-1340.jpg'
}, {
  name: 'Red',
  value: BackgroundSchemeType.red,
  backgroundColor: '#FBEBEC',
  backgroundImageIcon: 'https://img.lazcdn.com/us/media/8f601b6d4c55ce2ba19129fd391651f6-160-160.png',
  backgroundImage: 'https://img.lazcdn.com/us/media/18868f0b5b0cba734ce14b3ef4361558-1920-1340.jpg'
}];
export var getStyle = function getStyle(commonStyle) {
  var paddingTop = commonStyle.paddingTop,
    backgroundImage = commonStyle.backgroundImage,
    _commonStyle$backgrou = commonStyle.backgroundType,
    backgroundType = _commonStyle$backgrou === void 0 ? BackgroundType.color : _commonStyle$backgrou,
    backgroundColor = commonStyle.backgroundColor,
    colorScheme = commonStyle.colorScheme,
    backgroundScheme = commonStyle.backgroundScheme;
  var newStyle = {
    paddingTop: paddingTop
  };
  if (backgroundType === BackgroundType.image && backgroundImage !== null && backgroundImage !== void 0 && backgroundImage.length) {
    var _backgroundImage$, _backgroundImage$2;
    newStyle.backgroundImage = "url(".concat(((_backgroundImage$ = backgroundImage[0]) === null || _backgroundImage$ === void 0 ? void 0 : _backgroundImage$.url) || ((_backgroundImage$2 = backgroundImage[0]) === null || _backgroundImage$2 === void 0 ? void 0 : _backgroundImage$2.imgURL), ")");
    newStyle.backgroundSize = '1500px';
  }
  if (backgroundType === BackgroundType.color) {
    newStyle.backgroundColor = backgroundColor;
  }
  if (isNumber(backgroundScheme)) {
    var backgroundSchemeData = BackgroundSchemeList[backgroundScheme] || {};
    newStyle.backgroundColor = backgroundSchemeData.backgroundColor;
    newStyle.backgroundImage = "url(".concat(backgroundSchemeData.backgroundImage, ")");
    newStyle.backgroundSize = '1500px';
  }
  if (isNumber(colorScheme)) {
    var colorSchemeData = ColorSchemeList[colorScheme] || {};
    newStyle.backgroundColor = colorSchemeData.backgroundColor;
  }
  if (BackgroundSchemeType.default === backgroundScheme) {
    newStyle.backgroundColor = backgroundColor;
  }
  return newStyle;
};

// other
var eventMap = {
  mousedown: isMobileDevice ? 'touchstart' : 'mousedown',
  mousemove: isMobileDevice ? 'touchmove' : 'mousemove',
  mouseup: isMobileDevice ? 'touchend' : 'mouseup'
};
export var addEvent = function addEvent(elem, eventType, fn) {
  elem.addEventListener(eventMap[eventType], fn);
};
export var removeEvent = function removeEvent(elem, eventType, fn) {
  elem.removeEventListener(eventMap[eventType], fn);
};
export var query2obj = function query2obj() {
  var querystring = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
  var join = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';
  // remove first char '?'
  var str = "".concat(querystring || '').replace(/^\?/, '');
  return str === null || str === void 0 ? void 0 : str.split(split || '&').reduce(function (result, name) {
    var arr = name.split(join || '=');
    if (arr && arr.length > 0) {
      var key = arr.shift();
      if (key) {
        result[decodeURIComponent(key)] = decodeURIComponent(arr.join(join || '='));
      }
    }
    return result;
  }, {});
};
export var IMAGE_FORMAT_TIPS = 'Please upload .jpg and .png format only.';